(() => {
  angular.module('app.report').config(($routeProvider, $locationProvider) => {
    $locationProvider.html5Mode(true);

    $routeProvider
      .when('/affinity', {
        templateUrl: `../../assets/js/app/report/partials/affinity.html?v=${window.BUILD_VERSION}`,
        controller: 'AffinityReportController',
        controllerAs: 'affinityReport',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route)
        }
      })
      .when('/overview', {
        templateUrl: `../../assets/js/app/report/partials/overview.html?v=${window.BUILD_VERSION}`,
        controller: 'OverviewReportController',
        controllerAs: 'overviewReport',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route)
        }
      })
      .when('/profile', {
        templateUrl: `../../assets/js/app/report/partials/profile.html?v=${window.BUILD_VERSION}`,
        controller: 'ProfileReportController',
        controllerAs: 'profileReport',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route)
        }
      })
      .when('/reach', {
        templateUrl: `../../assets/js/app/report/partials/reach.html?v=${window.BUILD_VERSION}`,
        controller: 'ReachReportController',
        controllerAs: 'reachReport',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route)
        }
      })
      .when('/events',{
        templateUrl: `../../assets/js/app/report/partials/events.html?v=${window.BUILD_VERSION}`,
        controller: 'EventsReportController',
        controllerAs: 'eventsReport',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route)
        }
      })
      .when('/support', {
        templateUrl: '../../assets/js/app/report/partials/support.html',
        controller: 'SupportReportController',
        controllerAs: 'supportReport',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route)
        }
      })
      .when('/quality/:metric?', {
        templateUrl: `../../assets/js/app/report/partials/quality.html?v=${window.BUILD_VERSION}`,
        controller: 'QualityReportController',
        controllerAs: 'qualityReport',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route)
        }
      })
      .when('/delivery', {
        templateUrl: `../../assets/js/app/report/partials/delivery.html?v=${window.BUILD_VERSION}`,
        controller: 'DeliveryReportController',
        controllerAs: 'deliveryReport',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route)
        }
      });
  });
})();
